import { render, staticRenderFns } from "./CustomerInfoFinancial.vue?vue&type=template&id=0fb5c494"
import script from "./CustomerInfoFinancial.vue?vue&type=script&lang=js"
export * from "./CustomerInfoFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports